import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib';
import { GLYPH } from './glyphs';

export type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root>;

/**
 * Чекбокс по образцу списка multi (README «Поля форм»): 14×14, radius 9;
 * отмечен — фон и рамка wine-ink, «✓» 9 px ink-inverse; не отмечен — paper-pure, рамка line-field.
 */
export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        'flex size-14 shrink-0 cursor-pointer items-center justify-center rounded-9 border border-line-field bg-paper-pure',
        'data-[state=checked]:border-wine-ink data-[state=checked]:bg-wine-ink',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="text-[9px] leading-none text-ink-inverse">
        {GLYPH.check}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
